<script lang="ts">
const samples = new Map<string, Promise<ViewData>>()
</script>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { postViewRun, type ViewData } from '@/lib/api'
import { getRangeQuery } from '@/lib/data'
import { useRangeStore } from '@/stores/range'
import type { PageView, View } from '@/types'
import PageTile from './PageTile.vue'

const props = defineProps<{ view: View }>()

const emit = defineEmits<{ ready: [] }>()

const rangeStore = useRangeStore()
const data = ref<ViewData | null>(null)

const pageView = computed<PageView>(() => ({
  id: `preview-${props.view.id}`,
  page_id: 'preview',
  view_id: props.view.id,
  layout: { x: 0, y: 0, w: 1, h: 1 },
  status: 'active',
  created_at: '',
  updated_at: '',
}))

const getSample = (v: View): Promise<ViewData> => {
  const key = `${v.id}:${v.updated_at}`
  let held = samples.get(key)
  if (!held) {
    held = postViewRun({ ...getRangeQuery(rangeStore.state, {}), data: v.data ?? '', signal: v.signal, sample: true })
    samples.set(key, held)
    held.catch(() => samples.delete(key))
  }
  return held
}

onMounted(async () => {
  try {
    data.value = await getSample(props.view)
  } catch (err) {
    data.value = { from: '', to: '', rows: [], annotations: [], error: err instanceof Error ? err.message : 'Run failed' }
  }
  emit('ready')
})
</script>

<template>
  <PageTile :view="view" :page-view="pageView" :data="data" />
</template>
